module.exports = __webpack_public_path__ + "img/main_title2026.8dbaa16f.png";